<template>
  <of-dialog
    :title="formTitle"
    @onCancel="cancel"
    @onConfirm="confirm"
    :isConfirm="isConfirm"
    :width="width"
  >
    <div slot="content">
      <el-form
        ref="form"
        label-width="170px"
        :model="dataForm"
        :disabled="isdisableds"
        :rules="editFormRules"
      >
      <el-form-item label="会员编号：" prop="BusinessId">
          <el-input
            v-model="dataForm.BusinessId"
            clearable
            placeholder="请输入会员编号"
          ></el-input>
        </el-form-item>
        <el-form-item label="团体性质：" prop="GroupNature">
          <el-select v-model="dataForm.GroupNature" placeholder="请选择">
            <el-option
              v-for="item in groupnatureOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="企业名称：" prop="UnitName">
          <el-input v-model="dataForm.UnitName" clearable placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="单位性质：" prop="UnitNature">
          <el-select v-model="dataForm.UnitNature" placeholder="请选择">
            <el-option
              v-for="item in unitNatureOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="法人代表：" prop="LegalPerson">
          <el-input v-model="dataForm.LegalPerson" clearable placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="法人手机号码：" prop="LegalMobileNo" v-if="IsEnterprise">
          <el-input v-model="dataForm.LegalMobileNo" clearable placeholder="请输入法人手机号码"></el-input>
        </el-form-item>
        <el-form-item label="员工总数：" prop="EmployeesNumber" v-if="IsEnterprise">
          <el-input v-model="dataForm.EmployeesNumber" clearable placeholder="请输入员工总数"></el-input>
        </el-form-item>
        <el-form-item label="单位人数：" prop="EmployeesNumber" v-else>
          <el-input v-model="dataForm.EmployeesNumber" clearable placeholder="请输入干部职工总数"></el-input>
        </el-form-item>
        <el-form-item label="联系人（会员代表）：" prop="ContactUser">
          <el-input v-model="dataForm.ContactUser" clearable placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="常驻地区：" prop="Address">
          <el-input v-model="dataForm.Address" clearable placeholder="请输入通讯地址位"></el-input>
        </el-form-item>
        <el-form-item label="邮政编码：" prop="PostalCode">
          <el-input v-model="dataForm.PostalCode" clearable placeholder="请输入邮政编码"></el-input>
        </el-form-item>
        <el-form-item label="联系电话：" prop="Phone">
          <el-input v-model="dataForm.Phone" clearable placeholder="请输入联系电话"></el-input>
        </el-form-item>
        <el-form-item label="电子邮箱：" prop="Email">
          <el-input v-model="dataForm.Email" clearable placeholder="请输入电子邮箱"></el-input>
        </el-form-item>
        <el-form-item label="联系地址：" prop="ContactAddress">
          <el-input v-model="dataForm.ContactAddress" clearable placeholder="请输入联系地址"></el-input>
        </el-form-item>
        <el-form-item label="附件：" prop="File">
          <of-upload
            class="upload-demo"
            list-type="fileList"
            @onRemove="onRemove"
            @onUpLoad="onUpLoad"
            @onExceed="onExceed"
            @onPreview="onPreview"
            :limit="limitNum"
            :fileList="fileList"
            :class="{ hide: hideUploadEdit }"
          >
            <div slot="content">
              <el-button>上传文件</el-button>
            </div>
          </of-upload>
        </el-form-item>
        <el-form-item label="会员级别：" prop="Level">
          <el-select v-model="dataForm.Level" placeholder="请选择">
            <el-option
              v-for="item in levelOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="会员截止时间：" prop="ExpirationDate">
          <el-date-picker
            v-model="dataForm.ExpirationDate"
            type="datetime"
            value-format="timestamp"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="入会时间：" prop="ApplyTime_datepicker">
          <el-date-picker
            v-model="dataForm.ApplyTime"
            type="date"
            value-format="timestamp"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>
      </el-form>
    </div>
  </of-dialog>
</template>
<script>
import OfDialog from "@/components/controls/of_dialog/of_dialog";
import OfUpload from "@/components/controls/of_upload/of_upload";
import { mapGetters } from "vuex";
import { saveAs } from "file-saver";
import api from "@/modules/zjrc/api";

export default {
  name: "edit",
  props: {
    dataForm: {
      type: Object,
      default: null
    },
    formTitle: {
      type: String,
      default: ""
    }
  },
  data() {
    //手机号码验证规则
    var checkMobileNo = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入电话号码"));
      }
      // if (!/^1[0-9]{10}$/.test(value)) {
      //   return callback(new Error("无效手机号码"));
      // }
      callback();
    };
    //验证电子邮箱
    var checkEmail = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入电子邮箱"));
      }
      if (
        !/^[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*\.[a-z]{2,}$/.test(
          value
        )
      ) {
        return callback(new Error("无效电子邮箱"));
      }
      callback();
    };
    //验证传真号码
    var checkFax = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入身份证号码"));
      }
      if (!/^(\d{3,4}-)?\d{7,8}$/.test(value)) {
        return callback(new Error("无效身份证号码"));
      }
      callback();
    };
    //验证邮政编码
    var checkPostalCode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入邮政编码"));
      }
      if (!/^[0-9]{6}$/.test(value)) {
        return callback(new Error("无效邮政编码"));
      }
      callback();
    };
    return {
      editFormRules: {
        UnitName: {
          required: true,
          message: "请输入企业名称",
          trigger: "blur"
        },
        LegalPerson: {
          required: true,
          message: "请输入法人代表",
          trigger: "blur"
        },
        LegalMobileNo: {
          required: true,
          validator: checkMobileNo,
          trigger: "blur"
        },
        ContactUser: {
          required: true,
          message: "请输入联系人",
          trigger: "blur"
        },
        Phone: {
          required: true,
          validator: checkMobileNo,
          trigger: "blur"
        },
        Address: {
          required: true,
          message: "请输入通讯地址",
          trigger: "blur"
        },
        Email: {
          required: true,
          validator: checkEmail,
          trigger: "blur"
        },
        Fax: {
          required: true,
          validator: checkFax,
          trigger: "blur"
        },
        EmployeesNumber: {
          required: true,
          message: "请输入员工总数",
          trigger: "blur"
        },
        Describe: {
          required: true,
          message: "请输入企业简介",
          trigger: "blur"
        },
        File: {
          required: true,
          message: "请上传附件",
          trigger: "blur"
        },
        ApplyTime: {
          required: true,
          message: "请选择入会时间",
          trigger: "blur"
        },
        PostalCode: {
          required: true,
          validator: checkPostalCode,
          trigger: "blur"
        }
      },
      isConfirm: false,
      isdisableds: false,
      ishide: false,
      activeValue: 1,
      inactiveValue: 0,
      hideUploadEdit: false,
      //文化程度枚举
      groupnatureOptions: [
        { value: 0, label: "企业" },
        { value: 1, label: "单位" }
      ],
      //会员等级
      levelOptions: [
        { value: 0, label: "普通会员" },
        { value: 1, label: "特殊会员" },
        { value: 2, label: "永久会员" }
      ],

      fileList: [],
      limitNum: 10,
      width: "50%",
      //文化程度枚举
      unitNatureOptions: [
        { value: "城镇社区", label: "城镇社区" },
        { value: "农村单位", label: "农村单位" },
        { value: "企、事业单位", label: "企、事业单位" },
        { value: "学校", label: "学校" },
        { value: "医疗机构", label: "医疗机构" },
        { value: "其他", label: "其他" }
      ],
    };
  },
  computed: {
    ...mapGetters(["GetCurrentUserInfo"]),
    IsEnterprise() {
      return this.dataForm.GroupNature == 0 ? true : false;
    }
  },
  mounted() {
    // this.isType();
    let vm = this
    vm.getFile();
    if(vm.dataForm.Id){
      vm.dataForm.ExpirationDate = this.dataForm.ExpirationDate * 1000
    }
  },
  components: {
    OfDialog,
    OfUpload
  },
  methods: {
    isType() {
      this.formTitle == "查看详情"
        ? (this.isdisableds = true)
        : (this.isdisableds = false);
    },
    cancel() {
      this.$emit("formCallBack", null);
    },
    //新增
    confirm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.isConfirm = true;
          let params = Object.assign({}, this.dataForm);
          params.Status = 0;
          params.ApplyStatus = 0;
          params.UserId = this.GetCurrentUserInfo.Id;
          params.ApplyTime = params.ApplyTime / 1000;
          params.ExpirationDate = params.ExpirationDate / 1000
          api.SaveGroupMember(params)
            .then(rep => {
              this.isConfirm = false;
              if (rep.data.Code === 0) {
                this.$message({
                  message: "提交成功",
                  type: "success"
                });
                this.$emit("formCallBack", params);
              } else {
                this.$message({
                  message: rep.data.Message,
                  type: "error"
                });
              }
            })
            .catch(e => {
              this.isConfirm = false;
              this.$message({
                message: e.toString(),
                type: "error"
              });
            });
        }
      });
    },
    //删除附件
    onRemove(file) {
      for (var i = 0; i < this.fileList.length; i++) {
        if (this.fileList[i].url == file.url) {
          this.fileList.splice(i, 1);
        }
      }
      this.dataForm.File = JSON.stringify(this.fileList);
      this.hideUploadEdit = false;
    },
    //上传附件
    onUpLoad(file) {
      if (file.response.Code === 0) {
        const list = { name: file.name, url: file.response.Data.FileId };
        this.fileList.push(list);
        this.dataForm.File = JSON.stringify(this.fileList);
        if (this.fileList.length >= this.limitNum) {
          this.hideUploadEdit = true;
        }
        this.$message({
          message: "附件上传成功",
          type: "success"
        });
      }
    },
    onExceed() {
      this.$message({
        message: `只能选择 ${this.limitNum} 个文件`,
        type: "error"
      });
    },
    //点击下载
    onPreview(file) {
      saveAs("/yjrc_site/RC_File/Download?Id=" + file.url, file.name);
    },
    //初始化附件
    getFile() {
      if (
        this.dataForm.File === undefined ||
        this.dataForm.File === null ||
        this.dataForm.File == ""
      ) {
        return;
      }
      this.fileList = JSON.parse(this.dataForm.File);
      if (this.fileList.length >= this.limitNum) {
        this.hideUploadEdit = true;
      }
    }
  }
};
</script>

<style scoped>
.upload-demo >>> .el-upload input[type="file"] {
  display: none !important;
}
.upload-demo >>> .el-upload-list__item-delete {
  display: none !important;
}

.el-date-editor >>> .el-input__icon {
  display: none;
}

.el-date-editor >>> .el-input__inner {
  width: 90%;
}

/* .el-date-editor >>> .el-input__inner {
  width: 512.8px;
}
.el-select >>> .el-input__inner {
  width: 512.8px;
} */
</style>

<style>
.hide .el-upload--fileList {
  display: none;
}
</style>
